import { AnswerCommand } from 'core/commands/elements/answers/answer.abstract.command';
import { tactileoAnswersDTOTypes } from 'utils/activityItem.util';

export class CraftImageAnswerCommand extends AnswerCommand {
  constructor(craftImageQuestion) {
    super(tactileoAnswersDTOTypes.CRAFT_IMAGE_QUESTION, craftImageQuestion);
    this.crafted_image_url = craftImageQuestion.craftedImageUrl;
  }
}
